import Vue from 'vue'
import authService from '@/services/authentication'
import { bootInterceptors } from './interceptors.js'

import LoadingsPlugin from '@/plugins/loadings'
Vue.use(LoadingsPlugin)

const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import VueAxios from 'vue-axios'
import axios from 'axios'

Vue.use(VueAxios, axios)

export async function boot () {
    // Boot all configured interceptors
    bootInterceptors()

    // Restore authentication from token and fetch configurations/translations
    try {
        // Restore authentication from token (if available)
        await authService.restoreAuthentication()
        return true
    }
    catch (error) {
        return false
    }
}
